import React from 'react';
import { SUPPORT_EMAIL } from './constants';
export function Footer() {
  return <footer className="bg-golf-deep px-4 py-3 text-center text-white/70" data-id="element-60" data-mp="3gezdb400vr15">
      <p className="font-head text-[11px] font-semibold uppercase tracking-wide text-white sm:text-sm" data-id="element-61" data-mp="3ghc0bvkn0rl2">
        © 2026 GOLF COACH PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-0.5 max-w-3xl text-[11px] font-medium leading-snug sm:text-xs" data-id="element-62" data-mp="36q900vzj8gmu">
        This system is designed for professional development. Coaches remain responsible for adapting
        activities and coaching decisions to each golfer's individual needs and circumstances.
      </p>
      <nav className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[11px] font-semibold sm:text-xs" data-id="element-63" data-mp="3ldu5gwjvqrxx">
        <a href="#offer" className="transition-colors duration-150 ease-out hover:text-golf-lime" data-id="element-64" data-mp="3qf9qwppyz0gu">
          Terms &amp; Conditions
        </a>
        <span aria-hidden="true" data-id="element-65" data-mp="2eyjqjn8892v5">•</span>
        <a href="#offer" className="transition-colors duration-150 ease-out hover:text-golf-lime" data-id="element-66" data-mp="2ezl4q0kji5h3">
          Privacy Policy
        </a>
        <span aria-hidden="true" data-id="element-67" data-mp="3gapdzldx0oh1">•</span>
        <a href="#offer" className="transition-colors duration-150 ease-out hover:text-golf-lime" data-id="element-68" data-mp="3gbqyeggtmnbf">
          Contact
        </a>
      </nav>
      <p className="mt-0.5 text-[11px] font-medium sm:text-xs" data-id="element-69" data-mp="3v5dh4svufath">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-golf-lime transition-colors duration-150 ease-out hover:text-white" data-id="element-70" data-mp="3qaq1ljithqr1">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}